module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowLineRight_white.8adcd84f.svg";